/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { confirmDialog } from "primereact/confirmdialog";
import { ConfirmDialog } from "primereact/confirmdialog";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";

const SEARCH_FIELDS = ["nombre"];

export default function PlanesActividades() {
  const [loader, setLoader] = useState(true);
  const [planes, setPlanes] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearPlan(contenidoCampos) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/planificacion/planesactividades",
      contenidoCampos,
      (respuesta) => {
        navigate(`/config/planes-actividades/${respuesta.plan.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear plan",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre del plan",
            requerido: true
          },
          {
            nombre: "comentario",
            tipoitemformularioid: 11,
            etiqueta: "Comentario"
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear plan",
        callback: crearPlan,
        validar: true
      }
    ]
  };

  function eliminarPlan(plan) {
    confirmDialog({
      message: `¿Eliminar "${plan.nombre}"?`,
      header: "Confirmar eliminación",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Eliminar",
      rejectLabel: "Cancelar",
      acceptClassName: "p-button-danger",
      accept: () => {
        accessAPI(
          "DELETE",
          `admin/planificacion/planesactividades/${plan.id}`,
          null,
          () => {
            setPlanes((prev) => prev.filter((p) => p.id !== plan.id));
          },
          (respuesta) => {
            toast.current?.show({
              severity: "error",
              summary: "Error",
              detail: respuesta[0]?.msg || "Error al eliminar plan",
              sticky: true
            });
          }
        );
      }
    });
  }

  useEffect(() => {
    document.title = "Planes de Actividades";
    accessAPI(
      "GET",
      "admin/planificacion/planesactividades",
      null,
      (respuesta) => {
        setPlanes(respuesta.planes);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar planes",
          sticky: true
        });
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <ConfirmDialog />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo plan de actividades</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div>
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "1em",
              marginTop: "2em"
            }}
          >
            <Skeleton width="16rem" height="2rem" />
            <Skeleton width="2.5rem" height="2.5rem" />
          </div>
          <Skeleton width="100%" height="15rem" />
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton callback={() => setSideBar(true)}>Nuevo plan</Boton>
            }
          >
            Planes de Actividades
          </Titulo>

          <Card>
            <TablaFiltrable
              value={planes}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="planes_actividades"
              emptyMessage="No hay planes de actividades registrados"
              onRowClick={(e) =>
                navigate(`/config/planes-actividades/${e.data.id}`)
              }
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column field="nombre" header="Nombre" />
              <Column
                field="cantidadActividades"
                header="Actividades"
                style={{ width: "8rem", textAlign: "center" }}
              />
              <Column
                header="Estado"
                body={(rowData) => (
                  <Tag
                    severity={rowData.activo ? "success" : "danger"}
                    css={{ fontSize: "0.75rem" }}
                  >
                    {rowData.activo ? "Activo" : "Inactivo"}
                  </Tag>
                )}
                style={{ width: "8rem" }}
              />
              <Column
                body={(rowData) => (
                  <Boton
                    texto
                    rojo
                    chico
                    callback={(e) => {
                      e.stopPropagation();
                      eliminarPlan(rowData);
                    }}
                  >
                    <i className="pi pi-trash" />
                  </Boton>
                )}
                style={{ width: "4rem", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
